export const CHANNEL_OPTIONS = {
    ALL: "all",
    PUBLIC: "public",
    PRIVATE: "private",
};

export const DEFAULT_PERIODS = [
    { key: "year", startMonth: 1, endMonth: 12, labelKey: "DmsAnalytics.Period.FullYear", fallback: "Ano Todo" },
    { key: "q1", startMonth: 1, endMonth: 3, labelKey: "DmsAnalytics.Period.Q1", fallback: "Q1" },
    { key: "q2", startMonth: 4, endMonth: 6, labelKey: "DmsAnalytics.Period.Q2", fallback: "Q2" },
    { key: "q3", startMonth: 7, endMonth: 9, labelKey: "DmsAnalytics.Period.Q3", fallback: "Q3" },
    { key: "q4", startMonth: 10, endMonth: 12, labelKey: "DmsAnalytics.Period.Q4", fallback: "Q4" },
    { key: "h1", startMonth: 1, endMonth: 6, labelKey: "DmsAnalytics.Period.H1", fallback: "1º Sem" },
    { key: "h2", startMonth: 7, endMonth: 12, labelKey: "DmsAnalytics.Period.H2", fallback: "2º Sem" },
];

export const DEFAULT_MONTHS = [
    { value: 1, key: "January", labelKey: "DmsAnalytics.Month.January", fallback: "Jan" },
    { value: 2, key: "February", labelKey: "DmsAnalytics.Month.February", fallback: "Fev" },
    { value: 3, key: "March", labelKey: "DmsAnalytics.Month.March", fallback: "Mar" },
    { value: 4, key: "April", labelKey: "DmsAnalytics.Month.April", fallback: "Abr" },
    { value: 5, key: "May", labelKey: "DmsAnalytics.Month.May", fallback: "Mai" },
    { value: 6, key: "June", labelKey: "DmsAnalytics.Month.June", fallback: "Jun" },
    { value: 7, key: "July", labelKey: "DmsAnalytics.Month.July", fallback: "Jul" },
    { value: 8, key: "August", labelKey: "DmsAnalytics.Month.August", fallback: "Ago" },
    { value: 9, key: "September", labelKey: "DmsAnalytics.Month.September", fallback: "Set" },
    { value: 10, key: "October", labelKey: "DmsAnalytics.Month.October", fallback: "Out" },
    { value: 11, key: "November", labelKey: "DmsAnalytics.Month.November", fallback: "Nov" },
    { value: 12, key: "December", labelKey: "DmsAnalytics.Month.December", fallback: "Dez" },
];

export const CURRENT_YEAR = new Date().getFullYear();
export const DEFAULT_YEARS_RANGE = 5;
export const ALL_YEARS_VALUE = "all";
export const MAX_RECOMMENDED_YEARS = 5;
